export const ADD_WAYPOINT_VIEW_PARAM_KEY: string = 'waypointType'
export const EDIT_WAYPOINT_VIEW_PARAM_KEY: string = 'index'
